import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, useNavigate } from 'react-router-dom';
import A1 from '../Login/Chatbot.jpeg';
import axios from 'axios';

const Login = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false,
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    const { id, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [id]: type === 'checkbox' ? checked : value,
    });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Invalid email format';

    if (!formData.password.trim()) newErrors.password = 'Password is required';
    else if (formData.password.length < 6) newErrors.password = 'Password must be at least 6 characters';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setIsLoading(true);

      try {
        // Sending login request to backend API
        const response = await axios.post('https://rvapi.emedha.in/auth/api/api/loginPage', formData);
        console.log(response.data);
        if (response.data.success) {
          sessionStorage.setItem('user', JSON.stringify(response.data.user));
          sessionStorage.setItem('password', response.data.password);
          navigate('/dashboard');
        } else {
          setErrors({
            ...errors,
            password: response.data.message || 'Incorrect email or password, or account not approved.',
          });
        }
      } catch (error) {
        setErrors({
          ...errors,
          password: 'Login failed. Please try again later.',
        });
        console.error('Login error:', error);
      }

      setIsLoading(false);
    } else {
      console.log('Validation failed');
    }
  };


  return (
    <div className="container-fluid min-vh-100 d-flex justify-content-center align-items-center bg-light">
      <div className="card shadow-sm p-4" style={{ maxWidth: '400px', width: '100%' }}>
        <div className="text-center mb-4">
          <img src={A1} alt="ChatBot Services" style={{ width: '150px' }} />
          <h2 className="fw-bold text-primary">
            Emedha ChatBot <span className="text-success">Services</span>
          </h2>
          <p className="text-muted">Welcome back! 👋</p>
          <p>Please sign in to access your account.</p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">EMAIL</label>
            <input type="email" className="form-control" id="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" />
            {errors.email && <small className="text-danger">{errors.email}</small>}
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">PASSWORD</label>
            <input type="password" className="form-control" id="password" value={formData.password} onChange={handleChange} placeholder="Enter your password" />
            {errors.password && <small className="text-danger">{errors.password}</small>}
          </div>
          <div className="form-check mb-3">
            <input type="checkbox" className="form-check-input" id="rememberMe" checked={formData.rememberMe} onChange={handleChange} />
            <label className="form-check-label" htmlFor="rememberMe">Remember Me</label>
          </div>
          <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
        </form>
        <div className="text-center mt-3">
          <p>
            New on ChatBot Services{' '}
            <Link to="/em-registation" className="text-decoration-none">Create your free account</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
